
































































































import { tDeviceTransactionInfo } from '@/store/interfaces/transactions';
import { WithdrawalsParams } from '@/store/interfaces/withdrawals';
import Device from '@/components/TransactionTickets/Transfer/Detail/Device.vue';
import { status } from '@/util/transformString/translationsDecorator';
import { dateTime } from '@/util/filters';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  components: { Device, },
  props: {
    viewModal: {
      required: true,
      type: Boolean,
    },
    withdrawal: {
      required: true,
      type: Object as PropType<WithdrawalsParams>,
    },
  },
  data() {
    return {
      status,
    };
  },
  methods: {
    close(): void {
      this.$emit('update:viewModal', false);
    },
    refund(): void {
      this.syncedViewModal = false;
      this.$emit('refund');
    },
  },
  computed: {
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean): void {
        this.$emit('update:viewModal', value);
      },
    },
    fullName(): string {
      return `${this.withdrawal.user_first_name} ${this.withdrawal.user_last_name}`;
    },
    device(): tDeviceTransactionInfo {
      return {
        device_name: this.withdrawal.device_name,
        device_platform: this.withdrawal.device_platform,
        device_vendor: this.withdrawal.device_vendor,
        device_version: this.withdrawal.device_version,
      };
    },
    date(): string {
      return dateTime(this.withdrawal.created_at);
    },
  },
});
